import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';

import App from './app/app';

import './i18n/i18n';

const root = ReactDOM.createRoot(document.getElementById('self-service-app-root') as HTMLElement);

root.render(
  <StrictMode>
    <HashRouter>
      <App isLoading={true} />
    </HashRouter>
  </StrictMode>
);
